module.exports = __webpack_public_path__ + "static/media/latam-platinum.a43470fb.png";